var _mask, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasksIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_103_18538",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1287 37.8C15.1287 25.6498 24.9784 15.8 37.1287 15.8C49.2789 15.8 59.1287 25.6498 59.1287 37.8C59.1287 49.9503 49.2789 59.8 37.1287 59.8C24.9784 59.8 15.1287 49.9503 15.1287 37.8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1287 57.4C26.3039 57.4 17.5287 48.6248 17.5287 37.8H12.7287C12.7287 51.2758 23.6529 62.2001 37.1287 62.2001V57.4ZM56.7287 37.8C56.7287 48.6248 47.9534 57.4 37.1287 57.4V62.2001C50.6044 62.2001 61.5287 51.2758 61.5287 37.8H56.7287ZM37.1287 18.2C47.9534 18.2 56.7287 26.9753 56.7287 37.8H61.5287C61.5287 24.3243 50.6044 13.4 37.1287 13.4V18.2ZM37.1287 13.4C23.6529 13.4 12.7287 24.3243 12.7287 37.8H17.5287C17.5287 26.9753 26.3039 18.2 37.1287 18.2V13.4Z",
    fill: "#FFFCFC",
    mask: "url(#path-1-inside-1_103_18538)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4573 40.3L33.4573 44.8C33.4573 44.8 40.4662 35.0484 44.9573 28.8",
    stroke: "#3FA60F",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/TasksIcon.a5f3e9120dc6b83dae8c206591efc40e.svg";
export { ForwardRef as ReactComponent };